var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "放款信息",
        width: "600px",
        footer: false,
        destroyOnClose: ""
      },
      on: { cancel: _vm.close },
      model: {
        value: _vm.modalShow,
        callback: function($$v) {
          _vm.modalShow = $$v
        },
        expression: "modalShow"
      }
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-top": "-20px" } },
        [
          _c(
            "a-form-model",
            {
              attrs: {
                model: _vm.pageData,
                "label-col": _vm.labelCol,
                "wrapper-col": _vm.wrapperCol
              }
            },
            [
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "银行融资流水号：", prop: "loanApplyNo" }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.pageData.loanApplyNo) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "融资企业：", prop: "entName" }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.pageData.entName) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "融资金额：", prop: "amount" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("splitK")(_vm.pageData.amount)) +
                      " 元\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "放款日期：", prop: "startDate" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.moment(_vm.pageData.startDate).format("YYYY-MM-DD")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "到期日期：", prop: "loanEndDate" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm
                          .moment(_vm.pageData.loanEndDate)
                          .format("YYYY-MM-DD")
                      ) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "融资利率：", prop: "execRate" }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.pageData.execRate) + " %\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "融资利息：", prop: "interest" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("splitK")(_vm.pageData.interest)) +
                      " 元\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "银行手续费率：", prop: "factFeeRate" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pageData.factFeeRate) +
                      " %\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "银行手续费：", prop: "factFee" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("splitK")(_vm.pageData.factFee)) +
                      " 元\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "平台服务费率：", prop: "factFeeRate" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pageData.platformRate) +
                      " %\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "平台服务费：", prop: "factFee" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("splitK")(_vm.pageData.platformFee)) +
                      " 元\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "收款账号：", prop: "recvAcc" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pageData.recvAcc || "--") +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "a-form-model-item",
                {
                  staticClass: "loaned-item",
                  attrs: { label: "开户银行：", prop: "repayBankName" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.pageData.repayBankName || "--") +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-661504d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661504d1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/loanedDetailDialog.vue
// module id = ans2
// module chunks = 1